import { type Price, type Subscription } from 'src/types/microsoft365'

import moment from 'moment'

export const calculateAnnualizedPrice = (price: Price, subscription: Subscription): number => {
  // Get the base price
  let basePrice = price.erp

  // Calculate the annualized price based on billing cycle and term duration
  if (subscription.BillingCycle === 'monthly' && subscription.TermDuration === 'P1Y') {
    return basePrice / 12
  } else if (subscription.BillingCycle === 'monthly' && subscription.TermDuration === 'P3Y') {
    return basePrice / 36
  } else if (subscription.BillingCycle === 'annual' && subscription.TermDuration === 'P3Y') {
    return basePrice / 3
  } else {
    return basePrice
  }
}

export const formatPrice = (price: number, subscription: Subscription): string => {
  const formattedPrice = price.toFixed(2)
  if (subscription.BillingCycle === 'monthly') {
    return `£${formattedPrice} / Month`
  } else {
    return `£${formattedPrice} / Year`
  }
}

export const calculatePriceChange = (price: Price, subscription: Subscription, newQuantity: number, oldQuantity: number): number => {
  const annualizedPrice = calculateAnnualizedPrice(price, subscription)
  return annualizedPrice * (newQuantity - oldQuantity)
}

export const isExpiringSoon = (subscription: Subscription): boolean => {
  const commitmentEndDate = moment(subscription.CommitmentEndDate)
  const daysUntilCommitmentEnd = commitmentEndDate.diff(moment(), 'days')
  return daysUntilCommitmentEnd <= 30 && daysUntilCommitmentEnd > 0
}

export const getDaysUntilCommitmentEnd = (subscription: Subscription): number => {
  return moment(subscription.CommitmentEndDate).diff(moment(), 'days')
}

export const getCurrentTermStartDate = (subscription: Subscription): Date => {
  const now = moment()
  const commitmentStart = moment(subscription.EffectiveStartDate)

  let termMonths = 12 // default to 1 year
  if (subscription.TermDuration === 'P1M') termMonths = 1
  if (subscription.TermDuration === 'P3Y') termMonths = 36

  const monthsSinceStart = now.diff(commitmentStart, 'months')
  const completedTerms = Math.floor(monthsSinceStart / termMonths)

  return commitmentStart.add(completedTerms * termMonths, 'months').toDate()
}
